import { render, staticRenderFns } from "./DiscussionAdd.vue?vue&type=template&id=5d19c0f3&"
import script from "./DiscussionAdd.vue?vue&type=script&lang=js&"
export * from "./DiscussionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports